import React, { useState, useEffect } from "react";

// redux
import { connect } from "react-redux";

// routes
import AllRoutes from "routes/AllRoutes";

// bootstrap
import { Spinner, Modal } from "react-bootstrap";

// helpers functions
import { getCurrentUserFromLocalStorage, getFromLocalStorage, saveToLocalStorage } from "utlis/helpers/Common/CommonHelperFunctions";

// LAYOUT
import Layout from 'components/Layout'

// redux actions
import {
	saveCommonTokenToStore,
	saveCurrentUserToStore,
	authenticateUser,
	setTempOrderId,
} from "redux/actions/actionAuth";
import { setGlobalTheme, setGlobalLoading } from "redux/actions/actionCommon";
// actions
import { setCartDetails, setCartImages, setCartItem } from "redux/actions/actionCart";

// react toastify
import { toast, ToastContainer, Slide } from "react-toastify";

// styles
import { GlobalLayoutStyles } from 'styles/styledThemes/theme1/globalThemeStyles'

// APIs | cart api
import { getCartItems } from "utlis/Apis/Cart_API";

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";
import AgeModal from "components/CommonModals/AgeModal";

function App(props) {
	// props
	const {
		globalLoading,
		setGlobalLoading,

		setGlobalTheme,

		saveCommonTokenToStore,
		saveCurrentUserToStore,

		authenticateUser,
		isUserAuthenticated,
		tempOrderId,

		setCartItem,
		setCartImages,
		setCartDetails,

		setTempOrderId,
	} = props

	// consts
	const TEMP_ORDER_ID = `${new Date().getTime()}__${Math.random()}`
	const name_to_save_on_local_storage = `__toi_dd`
	const name_to_save_on_local_storage_for_age_varification = `__is_a_vd`

	// states
	const [authLoading, setAuthLoading] = useState(true);
	const [ageModalVisibility, setAgeModalVisibility] = useState(false);

	// handle age modal close
	const handleAgeModalClose = ev => {
		setAgeModalVisibility(false)
	}

	// showing age modal
	useEffect(() => {
		const isAgeVarified = getFromLocalStorage(name_to_save_on_local_storage_for_age_varification);

		// if temp order id exists in the local storage
		if (!isAgeVarified) {
			setAgeModalVisibility(true)
		}
	}, [name_to_save_on_local_storage_for_age_varification])

	// CHECKING TEMP ORDER ID
	useEffect(() => {
		const tempOrderId = getFromLocalStorage(name_to_save_on_local_storage);

		// if temp order id exists in the local storage
		if (tempOrderId) {
			// setting order id to the global store
			setTempOrderId(tempOrderId)
		} else {
			saveToLocalStorage(name_to_save_on_local_storage, TEMP_ORDER_ID)
			// setting order id to the global store
			setTempOrderId(TEMP_ORDER_ID)
		}
	}, [TEMP_ORDER_ID, name_to_save_on_local_storage, setTempOrderId])

	// SETTING GLOBAL THEME
	useEffect(() => {
		setGlobalTheme('theme1')
	}, [setGlobalTheme])

	// GETTING CART ITEM
	useEffect(() => {
		// checking if user exists in the local storae
		const currentUser = getCurrentUserFromLocalStorage();

		if (tempOrderId) { // if tempOrderId exists only then load cart items
			// enabling global loading
			setGlobalLoading(true)
			setTimeout(() => {
				// getting cart items from the database
				getCartItems(currentUser?.userToken ?? "", tempOrderId).then(res => {
					// disabling global loading
					setGlobalLoading(false)

					const resData = res.data;

					// console.log("res data ", resData);

					// if request succesfull
					if (resData && resData.success) {
						const cartData = resData.data;

						// saving items to global store
						setCartItem(cartData.content);
						setCartImages(cartData.images);
						setCartDetails({
							cart_discount: cartData.cart_discount,
							cart_items: cartData.cart_items,
							cart_qty: cartData.cart_qty,
							cart_sub_total: cartData.cart_sub_total,
							cart_total: cartData.cart_total,
							coupon_code: cartData.coupon_code,
							coupon_value: cartData.coupon_value,
							allCartData: cartData
						});
					}

					// if request is not succesfull
					if (resData && resData.error) {
						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(resData?.message || "Unknown error occured", {
							autoClose: 3000,
							onClose: () => { },
						});
					}
				}).catch((err) => {
					console.log(`${ERROR_WHILE__NAME} getCartItems `, err.message);

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(UNKNOWN_ERROR_OCCURED, {
						autoClose: 2500,
						onClose: () => {
							// disabling global loading
							setGlobalLoading(false)
						},
					});
				})
			}, 400);
		}
	}, [setGlobalLoading, tempOrderId, setCartDetails, setCartItem, setCartImages])

	// USE EFFECT: USER CHECK
	useEffect(() => {
		// CHECKING IF THE USER IS ALREADY LOGGED IN
		const currentUser = getCurrentUserFromLocalStorage();
		// if user exists
		if (currentUser) {
			// saving user details to the global store
			saveCommonTokenToStore(currentUser.userToken);
			saveCurrentUserToStore(currentUser);
			authenticateUser(true);

			// stop loading
			setTimeout(() => {
				setAuthLoading(false);
			}, 500);
		} else {
			// updating user details to the global store
			saveCommonTokenToStore("");
			saveCurrentUserToStore(null);
			authenticateUser(false);

			// stop loading
			setTimeout(() => {
				setAuthLoading(false);
			}, 500);
		}
	}, [saveCommonTokenToStore, saveCurrentUserToStore, authenticateUser]);


	return (
		<React.Fragment>
			<GlobalLayoutStyles />

			<div className="app-root">
				<Layout>
					{
						// IF USER IS AUTHENTICATED
						isUserAuthenticated ? (
							<AllRoutes authLoading={authLoading} />
						) : (
							// IF USER IS NOT AUTHENTICATED
							<AllRoutes authLoading={authLoading} />
						)
					}
				</Layout>

				{
					/* GLOBAL LOADING */
					globalLoading ? (
						<div className="global-loading d-flex align-items-center justify-content-center">
							<Spinner animation="border" role="status">
								<span className="visually-hidden">Loading...</span>
							</Spinner>
						</div>
					) : null
				}

				{/* GLOBAL TOAST:- FOR ONSCREEN NOTIFICATOINS */}
				<ToastContainer
					className="app-toast"
					position="top-center"
					hideProgressBar={true}
					draggable={false}
					closeOnClick={false}
					transition={Slide}
					pauseOnFocusLoss={false}
				/>
			</div>

			{/* modals */}
            <Modal show={ageModalVisibility} onHide={handleAgeModalClose} centered backdrop="static" size='md'>
                <Modal.Body>
                    <AgeModal
                        closeModal={handleAgeModalClose}
						nameToSave={name_to_save_on_local_storage_for_age_varification}
                    />
                </Modal.Body>
            </Modal>
		</React.Fragment>
	);
}


const getDataFromStore = (state) => {
	return {
		isUserAuthenticated: state.auth.isUserAuthenticated,
		tempOrderId: state.auth.tempOrderId,
		globalLoading: state.common.globalLoading,
	};
};

const dispatchActionsToProps = (dispatch) => {
	return {
		setGlobalTheme: themeName => dispatch(setGlobalTheme(themeName)),
		setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
		saveCommonTokenToStore: comonToken => dispatch(saveCommonTokenToStore(comonToken)),
		saveCurrentUserToStore: currentUser => dispatch(saveCurrentUserToStore(currentUser)),
		authenticateUser: bool => dispatch(authenticateUser(bool)),
		setCartDetails: cartDetails => dispatch(setCartDetails(cartDetails)),
		setCartItem: cartData => dispatch(setCartItem(cartData)),
		setCartImages: cartData => dispatch(setCartImages(cartData)),
		setTempOrderId: orderId => dispatch(setTempOrderId(orderId)),
	};
};

export default connect(getDataFromStore, dispatchActionsToProps)(App);